import { formatGaslessFeeSol } from "@/lib/fees";
import { Skeleton } from "./Skeleton";

interface GaslessFeeDisplayProps {
	feeSol?: number;
	isLoading?: boolean;
}

export function GaslessFeeDisplay({ feeSol, isLoading = false }: GaslessFeeDisplayProps) {
	return (
		<span className="gasless-row">
			<span className="gasless-badge">OBLIQ Gasless</span>
			<span className="fee-strikethrough">
				{isLoading ? <Skeleton width={72} height={12} /> : formatGaslessFeeSol(feeSol)}
			</span>
		</span>
	);
}
